module.exports = __webpack_public_path__ + "img/20200515_163231.8a3de2df.jpg";